import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useSelector as _useSelector, TypedUseSelectorHook } from 'react-redux';

import { WalkthroughTargetId } from './components/Walkthrough';

type SliceState = {
  availableWalkthroughTargets: Record<WalkthroughTargetId, boolean>;
};

export const useSelector: TypedUseSelectorHook<{
  freeTrialWalkthrough: {
    availableWalkthroughTargets: Record<WalkthroughTargetId, boolean>;
  };
}> = _useSelector;

const initialState: SliceState = {
  availableWalkthroughTargets: {
    'cache-settings': false,
    'render-counter': false,
  },
};

const renderSlice = createSlice({
  name: 'FreeTrialWalkthrough',
  initialState,
  reducers: {
    registerComponent: (state, action: PayloadAction<WalkthroughTargetId>) => {
      state.availableWalkthroughTargets[action.payload] = true;
    },
    unregisterComponent: (state, action: PayloadAction<WalkthroughTargetId>) => {
      state.availableWalkthroughTargets[action.payload] = false;
    },
  },
});

export const { registerComponent, unregisterComponent } = renderSlice.actions;
export const useAvailableTargets = () => useSelector((state) => state.freeTrialWalkthrough.availableWalkthroughTargets);
export default renderSlice.reducer;
